import { connect, ConnectedProps } from 'react-redux';
import querystring from 'querystring';
import { StateType } from '../../../../state/state.types';
import { getQueryParamsFromState } from '../../../state/utils';
import makeQueryParamsUtil from '../../../../../../shared/makeQueryParamsUtil';

const mapState = ({ queryParams }: StateType) => {
  const searchQueryUrl = querystring.stringify(
    makeQueryParamsUtil(getQueryParamsFromState(queryParams)),
  );

  return {
    originalQueryKey: queryParams.originalQueryKey,
    searchQueryUrl,
    type: queryParams.type,
  };
};

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
